import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, ClickAwayListener, Typography} from "@mui/material";
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core";


export default function RepricingAutoPriceTooltip({ isOpen, updated, same, increase, decrease, children }) {
	const handleClose = () => isOpen.value = false

	return <ClickAwayListener onClickAway={handleClose}>
		<Box sx={{ display: 'inline-block', position: 'absolute' }}>
			<TooltipSeeker
				useLight
				title={<Box sx={{ display: 'flex', flexDirection: 'column' }}>
					<Box component="strong">
						Nº updated products
					</Box>
					<Box sx={{ display: 'flex', gap: 1, fontSize: 24, alignItems: 'center' }}>
						<Box sx={{ fontSize: 30 }}>
							{updated}
						</Box>
						<Box sx={{ color: 'divider' }}>
							<IconSeeker icon="equals" /> {same}
						</Box>
						<Box sx={{ color: 'success.main' }}>
							<IconSeeker icon="arrow-up-right" /> {increase}
						</Box>
						<Box sx={{ color: 'error.main' }}>
							<IconSeeker icon="arrow-down-left" /> {decrease}
						</Box>
					</Box>
				</Box>}
				onClose={handleClose}
				open={isOpen.value}
				disableFocusListener
				disableHoverListener
				disableTouchListener
			>
				{children}
			</TooltipSeeker>
		</Box>
	</ClickAwayListener>
}